import { getProfileUser, getUserByEmail } from 'api/users/api';
import { TokenUserRoles } from 'api/users/schemas/Users';
import { ButtonGranite, LoaderGranite } from 'components';
import PageTitle from 'components/PageTitle';
import { usePermissions } from 'hooks/usePermissions';
import { ContentLayout } from 'layouts/ContentLayout/ContentLayout';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import RoleTag from 'screens/RolesPermissions/CustomRoles/RoleTag';

const User: FC = () => {
  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const { isSuperAdmin: hasTokenSuperAdminRole } = usePermissions();

  const { data: profileUser, isLoading: profileIsLoading } = useQuery(
    ['user', 'profile'],
    () => getProfileUser(),
    {
      refetchOnWindowFocus: false,
      enabled: !id,
    },
  );
  const { data: user, isLoading: userIsLoading } = useQuery(
    ['user', id],
    () => getUserByEmail({ email: id! }),
    {
      refetchOnWindowFocus: false,
      enabled: !!id,
    },
  );

  const data = id ? user : profileUser;

  const isLoading = id ? userIsLoading : profileIsLoading;

  const breadcrumbs = [
    {
      icon: 'home',
      label: 'User management',
      onClick: () => navigate('/users'),
    },
    {
      label: `${data?.name}`,
    },
  ];

  const role = useMemo(() => data?.roles?.[0], [data?.roles]);

  if (isLoading) return <LoaderGranite className="min-h-screen w-full" />;
  return (
    <ContentLayout className="invite-user min-h-screen !justify-start pb-8">
      <div className="mb-12 flex w-full items-center justify-between gap-6">
        <div className="flex items-end justify-start gap-6">
          <PageTitle title={data?.name ?? ''} breadcrumbs={breadcrumbs} />
          <RoleTag
            name={
              hasTokenSuperAdminRole && !id
                ? TokenUserRoles.SUPER_ADMIN
                : role?.name ?? ''
            }
            color={hasTokenSuperAdminRole && !id ? '' : role?.color ?? ''}
            className="h-[36px] px-3 py-1.5 !text-base"
          />
        </div>
        {!pathname.includes('/edit') ? (
          <ButtonGranite
            label="Edit user"
            size="large"
            onClick={() => {
              id ? navigate(`/users/edit/${id}`) : navigate(`/profile/edit`);
            }}
          />
        ) : null}
      </div>
      <Outlet />
    </ContentLayout>
  );
};

export default User;
